import { Link } from "gatsby";
import * as styles from "./footer.module.css";

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { isAndroid, isIOS } from "react-device-detect";
import { StaticImage } from "gatsby-plugin-image";

const Footer = () => {
  return (
    <>
      <div className={styles.footerBar}>
        <Container fluid className={styles.container}>
          <Row>
            <Col sm={12} md={3} className={styles.colFooterImg}>
              <StaticImage
                className={styles.jenny}
                alt="AWS"
                src="../../images/Jenny.png"
                width={100}
              />
            </Col>
            <Col sm={12} md={3} className={styles.colFooter}>
              <Row>
                <div className="menu-headings">Conócenos</div>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/quienes-somos" className="submenus">
                  Quienes somos
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/preguntas-frecuentes" className="submenus">
                  Preguntas Frecuentes
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/casham-fwy" className="submenus">
                  Videotutoriales
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <div className="submenus">Contacto:</div>
              </Row>
              <Row className={styles.colFooter}>
                <div className="submenus">hola@casham.app</div>
              </Row>
            </Col>
            <Col sm={12} md={3} className={styles.colFooter}>
              <Row>
                <div className="menu-headings">Legales</div>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/tos" className="submenus">
                  Términos, privacidad y derechos ARCO
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <div className="menu-headings">Descarga</div>
              </Row>
              <Row>
                <Row className='footerStores' >
                  {((!isAndroid && !isIOS) || isAndroid) && (
                    <Col>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const aToPage = document.createElement("a");
                          aToPage.setAttribute(
                            "href",
                            "https://play.google.com/store/apps/details?id=com.mawulisa.casham"
                          );
                          aToPage.setAttribute("target", "_blank");
                          aToPage.setAttribute("rel", "noopener noreferrer");
                          aToPage.click();
                        }}
                      >
                        <StaticImage
                          alt="Android"
                          src="../../images/v2/Nav Bars/Bottom/1x/Androidmdpi.png"
                          width={30}
                        />
                      </div>
                    </Col>
                  )}
                  {((!isAndroid && !isIOS) || isIOS) && (
                    <Col>
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const aToPage = document.createElement("a");
                          aToPage.setAttribute(
                            "href",
                            "https://apps.apple.com/mx/app/casham/id1493246036"
                          );
                          aToPage.setAttribute("target", "_blank");
                          aToPage.setAttribute("rel", "noopener noreferrer");
                          aToPage.click();
                        }}
                      >
                        <StaticImage
                          alt="Apple"
                          src="../../images/v2/Nav Bars/Bottom/1x/Applemdpi.png"
                          width={30}
                        />
                      </div>
                    </Col>
                  )}
                </Row>
              </Row>
            </Col>
            <Col sm={12} md={3} className={styles.colFooter}>
              <Row>
                <div className="menu-headings">Servicios Casham</div>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/prestamo-personal" className="submenus">
                  Préstamo Personal.
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/prestamo-sin-buro" className="submenus">
                  Préstamo sin buró.
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/prestamo-rapido" className="submenus">
                  Préstamo rápido.
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/prestamo-en-linea" className="submenus">
                  Préstamo en línea.
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/prestamos-de-nomina" className="submenus">
                  Préstamos de nómina.
                </Link>
              </Row>
              <Row className={styles.colFooter}>
                <Link to="/programa-de-descuentos" className="submenus">
                  Programa de descuentos.
                </Link>
              </Row>
            </Col>
          </Row>
          <Row className={styles.containerLogosHelp}>
            <Col>
              <div className="footer">
                *Línea de crédito en pesos mexicanos, aprobación sujeta a
                evaluación de la documentación proporcionada por el solicitante,
                aceptación de nuestros términos de servicio y cumplimiento de
                nuestras políticas de uso. Casham es una comunidad basada en la
                confianza y el respeto mutuos. Para participar debes tener por
                lo menos 18 años cumplidos y ser residente legal de la República
                Mexicana. Toda solicitud de inscripción está sujeta a aprobación
                por parte nuestra. Los beneficios y precio de la suscripción a
                Casham Prime están sujetos a cambio sin previo aviso.
                ¿Preguntas? Visita nuestros términos de servicio, aviso de
                privacidad y preguntas frecuentes. Trabajamos con empresas de
                prestigio como proveedores de tecnología, bancos, y otras
                instituciones reguladas.
              </div>
            </Col>
          </Row>
          <Row
            className={styles.containerLogosHelp}
            style={{ textAlign: "center", display: "flex" }}
          >
            <Col>
              <StaticImage
                className="imgFooter"
                alt="Banco de Mexico"
                src="../../images/v2/Nav Bars/Bottom/1x/Banco de Mexicomdpi.png"
                layout="constrained"
                width={60}
              />
              <StaticImage
                className="imgFooter"
                alt="Condusef"
                src="../../images/v2/Nav Bars/Bottom/1x/Condusefmdpi.png"
                layout="constrained"
                width={60}
              />
              <StaticImage
                className="imgFooter"
                alt="AWS"
                src="../../images/v2/Nav Bars/Bottom/1x/AWSmdpi.png"
                layout="constrained"
                width={60}
              />
              <StaticImage
                className="imgFooter"
                alt="Digital Ocean"
                src="../../images/v2/Nav Bars/Bottom/1x/Digital Oceanmdpi.png"
                layout="constrained"
                width={60}
              />
              <StaticImage
                className="imgFooter"
                alt="Profeco"
                src="../../images/v2/Nav Bars/Bottom/1x/Profecomdpi.png"
                layout="constrained"
                width={60}
              />
              <StaticImage
                className="imgFooter"
                alt="Scotia"
                src="../../images/v2/Nav Bars/Bottom/1x/Scotiamdpi.png"
                layout="constrained"
                width={60}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Footer;
